export default {
    'name': 'dualCitations',
    'label': 'patent-view.Citation',
    'getComponent': () => import('./dual-citation.vue'),
    'tabIndex': 7,
    'left': true,
    'right': true,
    'singleView': false,
    'aclCheckKey': 'citation',
};
